import { useEffect, useRef, useState } from 'react'

const useOverflowDetector = (ref: React.RefObject<HTMLTableElement>) => {
  const [hasHorizontalOverflow, setHasHorizontalOverflow] = useState(false)
  const [height, setHeight] = useState(0)
  const tableWidth = useRef<number | null>(null)

  useEffect(() => {
    const { current } = ref
    if (current) {
      const timeoutId = setTimeout(() => {
        setHeight(current.scrollHeight)
        setHasHorizontalOverflow(current.scrollWidth > current.offsetWidth)
        // need to delay 1000ms Otherwise the overflow element cannot be detected in table tag
      }, 1000)

      const resizeObserver = new ResizeObserver((entries) => {
        // Check if the client width of the table has changed
        const { clientWidth } = entries[0].target
        if (clientWidth !== tableWidth.current) {
          tableWidth.current = clientWidth
          setHasHorizontalOverflow(current.scrollWidth > current.offsetWidth)
        }
      })

      resizeObserver.observe(current)

      return () => {
        clearTimeout(timeoutId)
        resizeObserver.unobserve(current)
      }
    }
    // need this "return" Otherwise useEffect will complain about no all code path return a value
    return
  }, [ref])

  return { hasHorizontalOverflow, height }
}

export default useOverflowDetector
